import { Button, Group, Modal, Text } from '@mantine/core';

const InvalidRecommenderModal = ({ show, close }) => {
  return (
    <Modal opened={show} onClose={() => close()} title="Invalid Product Blocks Detected">
      <Text mb="md">
        Please ensure that all product blocks in your email body have both a template and a product feed selected before
        proceeding.
      </Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={() => close()}>
          Close
        </Button>
      </Group>
    </Modal>
  );
};

export default InvalidRecommenderModal;
